import { useState, useEffect } from 'react';
import { branchAPI } from '../../../services/api';
import { useTranslation } from 'react-i18next';
import { fi } from 'date-fns/locale';

export const useDashboardFilters = (user, isSuperAdmin) => {
    const { t } = useTranslation();
    const [branches, setBranches] = useState([]);
    const [filters, setFilters] = useState({
        branch: '',
        representative: '',
        doctorSpecialization: '',
        patient: '',
        doctor: '',
        radiologist: '',
        scan: [],
        scanCategory: '',
        technician: '',
        startDate: null,
        endDate: null,
        page: 1,
        limit: 10
    });

    useEffect(() => {
        const fetchBranchesAndSetDefault = async () => {
            if (!user) return;

            try {
                const res = await branchAPI.getActiveBranches();
                const branchList = res.data.data || [];
                setBranches(branchList);

                if (!isSuperAdmin && user?.branch) {
                    setFilters(f => ({ ...f, branch: user.branch }));
                }
            } catch (err) {
                if (err.response?.status === 403) {
                    console.error('No permission to view branches');
                } else {
                    console.error('Error fetching branches');
                }
                setBranches([]);
            }
        };

        fetchBranchesAndSetDefault();
    }, [isSuperAdmin, user, filters.branch]);

    // Determine allowed branches for the user
    const allowedBranches = isSuperAdmin ? branches : branches.filter(b => b._id === user?.branch);
    const canSelectBranch = isSuperAdmin;
    const branchSelectValue = canSelectBranch ? (filters.branch || '') : (user?.branch || '');

    return {
        filters,
        setFilters,
        branches,
        allowedBranches,
        canSelectBranch,
        branchSelectValue
    };
};